import axiosInstance from "@/utils/axiosInstance";
import axiosInstanceSession from "@/utils/axiosInstanceSession";
import router from "@/router";
import store from "@/store";
import { wrapFetchValue } from "@/store/modules/storeCache";

const baseUrl = `api/auth`;

const state = {
  invitationBy: null,
};

const getters = {};

const mutations = {
    setInvitationBy(state, payload) {
    state.invitationBy = payload.invitationBy || null;
  },
};

const actions = {
  preLogin({ commit }, payload: { phoneOrEmail: string }) {
    return axiosInstance.post(`${baseUrl}/pre-login`, payload).then((response) => response.data);
  },
  async loginWithCredential({ commit }, payload: { login: string, password: string }) {
    const user = await axiosInstanceSession.post(`${baseUrl}/login/credentials`, {
      login: payload.login,
      password: payload.password,
    }).then((response) => response.data);
    store.commit("loginType", "credentials");
    try {
      await store.dispatch("auth/afterLogin", { user });
    } catch (e) {
      // tslint:disable-next-line:no-console
      console.error(e);
    }
  },
  async loginWithToken({ commit }, payload: { token: string }) {
    try {
      const user = await axiosInstanceSession.post(`${baseUrl}/login/token`, {
        token: payload.token,
      }).then((response) => response.data);
      store.commit("loginType", "token");
      await store.dispatch("auth/afterLogin", { user });
    } catch (e) {
      // tslint:disable-next-line:no-console
      console.error(e);
    }
  },
  async loginWithNfc({ commit }, jwt) {
    const user = await axiosInstance.post(`${baseUrl}/login/nfc`, { jwt });
    await store.commit("loginType", "NFC");
    await store.dispatch("auth/afterLogin", { user });
  },
  async afterLogin({ commit }, { user }: { user: any }) {
    // tslint:disable-next-line:no-console
    console.log("after login", user);
    if (!user) {
      // tslint:disable-next-line:no-console
      console.error(`user missing in function afterLogin`);
      return;
    }

    await store.dispatch("auth/resetUser");
    await commit("currentUser", user, { root: true });

    if (store.getters["oauth/getAccessToken"]) {

      if (!store.getters.currentUser.isAdmin) {
        const company = await store.dispatch("companies/readById", { id: store.getters["oauth/getCompanyId"] });
        store.commit("companiesList", [company]);
        await store.dispatch("autoSelectEnvCompany");
      }

    } else {

      if (!store.getters.currentUser.isAdmin) {
        const companies = await store.dispatch("auth/getMyCompanies").then((response) => response.rows);
        store.commit("companiesList", companies);
        await store.dispatch("autoSelectEnvCompany");
      }

      try {
        store.getters.currentUser.isAdmin ?
          await store.dispatch("oauth/adminTokenBySession") :
          await store.dispatch("oauth/tokenBySession", { companyId: store.getters.envCompanyId });
      } catch (e) {
        // case where the user can not have token for the selected company
        store.commit("oauth/reset");
        await store.dispatch("auth/logout", { user });
      }
    }

    if (store.getters["oauth/getAccessToken"]) {
      // Fetch nav
      if (!store.getters["nav/isNavFetched"]) {
        await store.dispatch("nav/fetchNavItemList");
      }

      if (!store.getters.currentUser.isAdmin) {
        await store.dispatch("users/getRelays", { userId: store.getters.currentUser.id });
      }
    }
    // utile ?
    await store.dispatch("banner/setHasUserPassword", !!store.getters.currentUser.password);

  },
  async logout({ commit }, payload: {}) {
    return axiosInstanceSession.get(`${baseUrl}/logout`)
      .finally(async () => {
        await store.dispatch("auth/resetUser");
        store.commit("loginType", null);
        store.commit("envCompany", null);
        return router.push({ name: "login" });
      });
  },
  async resetUser({ commit }, payload) {
    store.commit("currentUser", null);
    await store.dispatch("banner/setHasUserPassword", null);
    store.commit("companiesList", []);
    store.commit("nav/reset");
    await store.dispatch("banner/setLogAs", null);
    await store.dispatch("banner/setCommunicate", null);
    store.commit("oauth/reset");
  },
  async logAs({ commit }, payload: { user }) {
    return axiosInstanceSession.post(`${baseUrl}/log-as`, { userId: payload.user.id })
      .then(async (response) => {
        await store.dispatch("auth/resetUser");
        store.commit("envCompany", null);
        window.location.reload();
      });
  },
  communicate({ commit }) {
    return wrapFetchValue(state, `${baseUrl}/communicate`, () => {
      return axiosInstanceSession.get(`${baseUrl}/communicate`, {})
        .then(async (response) => {
          await store.dispatch("banner/setCommunicate", response.data);
        });
    });
  },
  validateUser({ commit }, payload: { token: number }) {
    return axiosInstance.put(`${baseUrl}/validate-user`, {
      token: payload.token,
    }).then((data) => data.data);
  },
  getConnectedUser({ commit }, payload: { query: object }) {
    return axiosInstanceSession.get(`${baseUrl}/me`)
      .then((data) => data.data);
  },
  getMyCompanies() {
    return axiosInstanceSession
      .get(`${baseUrl}/my-companies`)
      .then((response) => response.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
